import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledContainerWrapper = styled.div`
  width: 22vw;
  background: ${COLORS.GRAY_94};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
`;

export const StyledDeliveryErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  &&& button {
    white-space: break-spaces;
  }
`;

export const StyledDeliveryErrorText = styled.div`
  color: ${COLORS.RED};
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
`;
